export const returnsContext = {
  getByPage: '/web-api/orders/refund',
  getReturn: '/order-service/rest/api/external/orders/',
  getReceipt: '/fiscalization-service/api/external/receipt/',
  comment: '/order-service/rest/api/external/orders/{id}/comment',
  performActionActive: '/order-service/rest/api/external/orders/{id}/performAction',
};
